import { render } from "./ReviewSummary.vue?vue&type=template&id=46c51306&scoped=true"
import script from "./ReviewSummary.vue?vue&type=script&lang=js"
export * from "./ReviewSummary.vue?vue&type=script&lang=js"

import "./review-summary.scss?vue&type=style&index=0&id=46c51306&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c51306"]])

export default __exports__